import React, {
  cloneElement,
  CSSProperties,
  HTMLAttributes,
  MouseEvent
} from "react";

type Props = {
  /**
   * Label is used for logs and accessibility.
   * It's not visible.
   */
  label: string;
  children: React.ReactElement;
  testId?: string;
  onClick: (e: MouseEvent<SVGSVGElement, MouseEvent>) => void;
  style?: CSSProperties;
} & HTMLAttributes<SVGSVGElement>;

export const IconButton = ({
  children,
  label,
  testId,
  onClick,
  style,
  ...rest
}: Props) => {
  return cloneElement(children, {
    style: {
      cursor: "pointer",
      ...style
    },
    "aria-label": label,
    "data-loglabel": label,
    tabIndex: "0",
    ...(testId && { "data-testid": testId }),
    onClick,
    ...rest
  });
};
